import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mg',
    fullName: 'Malagasy',
    nativeName: 'Malagasy',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Misy zavatra mahagaga ho avy",
    landing_subtitle: "ArgVoid dia studio fampivoarana fampiharana sy lalao. Araho hatrany fa ho avy tsy ho ela ny zava-baovao!",
    select_language: "Select Language",
    search_placeholder: "Fikarohana fiteny...",
    terms_title: "Fepetran'ny serivisy",
    policy_title: "politika fiarovana fiainan'olona",
    cookies_title: "Politika cookie",
    terms_content: `
        <strong>1. Fanekena ny Terms</strong><br>
        Amin'ny fidirana amin'ny ArgVoid dia ekena ireo fepetran'ny serivisy ireo. Raha tsy ekena ireo fepetra ireo dia tsy tokony hampiasaina ny serivisy.<br><br>

        <strong>2. Fampiasana Platform</strong><br>
        ArgVoid sy ny fampiharana azy dia omena "toy ny misy" ho an'ny tanjona fampahafantarana sy famoronana. Ny serivisy dia tsy maintsy ampiasaina amin'ny tanjona ara-dalàna ihany.<br><br>

        <strong>3. Fitondran-tena voarara</strong><br>
        Voarara tanteraka ny fitrandrahana ny faharefoan'ny vohikala, ny fandefasana spam, na ny fiezahana miditra amin'ny fotodrafitrasa tsy ara-dalàna.<br><br>

        <strong>4. Fampitandremana</strong><br>
        Ny sehatra sy ny serivisy dia azo ovaina amin'ny fotoana rehetra tsy misy fampandrenesana. Tsy misy fiantohana omena momba ny fotoana fiasana na ny fisian'ny serivisy.
    `,
    policy_content: `
        <strong>1. Fanangonana fampahalalana</strong><br>
        Ny sehatra dia tsy mitaky fanamarinana ny mpampiasa na famoronana kaonty amin'izao fotoana izao. Tsy misy fampahalalana momba ny tena manokana (toy ny anarana na adiresy mailaka) voaangona mavitrika avy amin'ny mpitsidika.<br><br>

        <strong>2. Takelaka data</strong><br>
        Ny fanadihadiana fototra sy tsy fantatra anarana dia azo angonina mba hahatakarana ny fifamoivoizana amin'ny tranokala sy hanatsarana ny fampiharana. Ity angona ity dia tsy mifandray amin'ny mombamomba ny mpampiasa tsirairay.<br><br>

        <strong>3. Serivisy an'ny antoko fahatelo</strong><br>
        Ireo mpamatsy antoko fahatelo dia azo ampiasaina amin'ny serivisy fampiantranoana sy famakafakana. Ny fomba fiainana manokana ataon'ireo mpamatsy tsirairay ireo dia mifehy ny angon-drakitra tsy fantatra anarana voahodina ao amin'ny fotodrafitrasany.<br><br>

        <strong>4. Takelaka data </strong><br>
        Ny fepetra fiarovana ara-drariny dia ampiharina mba hiarovana ny sehatra. Na izany aza, tsy misy fomba fampitana amin'ny Internet azo antoka tanteraka.<br><br>
    `,
    cookies_content: `
        <strong>1. Inona no atao hoe Cookies sy fitahirizana eo an-toerana?</strong><br>
        Cookies sy navigateur fitahirizana eo an-toerana dia rakitra angona kely voatahiry ao amin'ny fitaovana mba hahatsiarovana ny safidin'ny fanefena mandritra ny fitsidihana.<br><br>

        <strong>2. Ny tanjona fampiasana</strong><br>
        Ny navigateur LocalStorage dia ampiasaina amin'ny fomba hentitra mba hitahiry ny fandrindrana, toy ny:<br>
        - Safidin'ny fiteny<br>
        - Fikirakirana amin'ny mpampiasa interface tsara (ohatra: lamina na lohahevitra)<br>
        - Cache fampiharana vonjimaika<br><br>

        <strong>3. Tsy misy Tracking</strong><br>
        Tsy ampiasaina amin'ny dokam-barotra na fanaraha-maso ataon'ny antoko fahatelo ny cookies sy fitahirizana eo an-toerana. Ny angon-drakitra voatahiry rehetra dia natao ho an'ny fiasa fototra amin'ny sehatra.<br><br>

        <strong>4. Control</strong><br>
        Ny angon'ny navigateur dia azo esorina amin'ny fotoana rehetra amin'ny alàlan'ny firafitry ny navigateur, izay hamerina ny fanovana eo an-toerana.
    `,
    cookie_consent_text: "Mampiasa cookies fototra izahay mba hiantohana fa miasa tsara ny tranokala, toy ny fitazonana ny fotoam-pivorianao ho mavitrika, ny fitahirizana ny safidinao amin'ny fiteny, ary ny fanamafisam-peo hafa.",
    read_policy: "Vakio ny Politikan'ny Cookie",
    support_title: "Contact Support",
    support_subject_label: "-DAHATSORATRA",
    support_message_label: "hAFATRA",
    support_submit_button: "Alefaso hafatra",
    support_hint: "Fanamarihana: Ity dia hanokatra ny fampiharana mailaka default handefasana ny hafatra.",
    support_success_msg: "Manokatra ny fampiharana mailakao...",
    support_error_msg: "Tsy nahavita nandefa hafatra. Andramo indray rahatrizay.",
    explorer_title: "mpikaroka tany vaovao",
    history_title: "FIAINANY TALOHA",
    animation_title: "Animation",
    config_title: "fanahafana",
    tool_mouse: "Fidio (Ctrl+M)",
    tool_brush: "Borosy (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Mafy/Mazava)",
    tool_eraser: "Famafana (Ctrl+E)",
    tool_brush_size: "Ahitsio ny haben'ny borosy",
    tool_bucket: "Fenoy (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Ahodina (Ctrl+Shift+R)",
    tool_flip_h: "Atsipazo H (Ctrl+Shift+H)",
    tool_flip_v: "Atsipazo V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "sakany",
    label_height: "hahavony",
    label_frames: "Isan'ny Frames",
    label_animation: "Style Animation",
    label_background_color: "Loko lafika",
    label_interval: "Elanela",
    tool_anim_config: "Animation Configuration",
    label_new_width: "New Width",
    label_new_height: "Haavo vaovao",
    label_apply: "AMPIHARO",
    label_colors: "loko",
    label_size: "Size",
    label_tolerance: "fandeferana",
    val_horizontal: "marindrano",
    val_vertical: "mijidina",
    val_sequence: "filaharana",
    val_bounce: "Aza kivy",
    val_random: "kianjoanjo",
    val_solid: "mafy",
    val_clear: "Mazava",
    action_add_sheet: "Taratasy vaovao",
    action_import: "Import",
    action_export: "fanondranana",
    action_sort_projects: "Sort",
    sort_date_old: "Voalohany indrindra",
    sort_date_new: "Vaovao voalohany",
    sort_name_az: "Anarana (A-Z)",
    sort_name_za: "Anarana (Z-A)",
    action_new_sprite: "Sprite vaovao",
    action_new_project: "Tetikasa vaovao",
    modal_save_all_title: "Tehirizo ny fanovana rehetra",
    modal_save_all_desc: "Safidio ny fananana hotehirizina:",
    modal_save_selected: "Save Voafantina",
    action_saved: "voavonjy",
    modal_create_sprite_title: "Mamorona Sprite Vaovao",
    modal_create_project_title: "Mamorona tetikasa vaovao",
    modal_add_sheet_title: "Hanampy takelaka vaovao",
    modal_rename_sheet_title: "Avereno anarana ny Sheet",
    modal_rename_sprite_title: "Avereno anarana Sprite",
    modal_delete_sprite_title: "Fafao ny Sprite",
    modal_delete_project_title: "Fafao ny tetikasa",
    modal_delete_sheet_title: "Fafao ny takelaka",
    placeholder_sprite_name: "Anarana",
    placeholder_project_name: "Anarana",
    placeholder_sheet_name: "Anarana",
    placeholder_new_name: "Anarana vaovao",
    action_create: "MANANGANA",
    action_add: "hametraka",
    action_rename: "Hanova anarana",
    action_duplicate: "miverina indroa",
    action_delete: "Mamafa",
    action_cancel: "hanafoana",
    confirm_delete_sprite: "Tena te-hamafa ity sprite ity ve ianao?",
    confirm_delete_project: "Tena te-hamafa ity tetikasa ity ve ianao? Ny sprites rehetra dia hesorina.",
    confirm_delete_sheet: "Tena te-hamafa ity taratasy ity ve ianao?",
    err_select_sprite: "Mifidiana sprite aloha.",
    err_select_project: "Misafidiana tetikasa iray aloha.",
    err_name_empty: "Tsy azo foanana ny anarana.",
    err_sprite_exists: "Efa misy ny sprite manana an'io anarana io.",
    err_project_exists: "Efa misy tetikasa manana io anarana io.",
    err_no_content: "Tsy misy votoaty hotehirizina.",
    err_no_changes: "Tsy misy fiovana hotehirizina.",
    err_delete_last_sheet: "Tsy afaka mamafa ny takelaka farany.",
    err_extract_frames: "Tsy afaka naka sary na inona na inona.",
    err_indexeddb: "Tsy nahomby teo an-toerana. Mety tsy mahazaka IndexedDB ny navigateur anao.",
    msg_upload_success: "Nahomby ny fandefasana: {0}",
    msg_upload_failed: "Tsy nahomby ny fandefasana: {0}",
    msg_save_success: "Vonjeo mahomby.",
    msg_saving: "Mitahiry...",
    msg_multi_save_result: "Fananana {0} voatahiry. {1} tsy fahombiazana.",
    menu_title: "sakafo",
    menu_save: "afa-tsy",
    menu_save_all: "Vonjeo daholo",
    menu_support: "Contact Support",
    label_local_storage: "Fitehirizana eo an-toerana",
    label_sign_in: "Hiditra",
    modal_export_title: "Export Sprite",
    label_filename: "Anaran'ny fisie",
    label_format: "endrika",
    action_export_confirm: "fanondranana",
};

export default translations;
